import styled from '../../styles/theme';
import { LinkTemplate } from './LinkTemplate';

export const LinkStyled = styled(LinkTemplate)`
    a {
        color: ${({ theme }) => theme.colors.black};
        text-decoration: none;
        :hover {
            text-decoration: underline;
        }
    }

    svg {
        height: 1rem;
    }
`;
